var _templateObject = _taggedTemplateLiteralLoose(['\n  min-width: 100%;\n  min-height: 100%;\n  background: linear-gradient(to right bottom, ', ', ', ');\n  padding: ', ';\n'], ['\n  min-width: 100%;\n  min-height: 100%;\n  background: linear-gradient(to right bottom, ', ', ', ');\n  padding: ', ';\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component, Fragment } from 'react';
import styled, { withTheme } from 'styled-components';
var Container = styled.div(_templateObject, function (props) {
  return props.from;
}, function (props) {
  return props.to;
}, function (props) {
  return props.padding || '0px';
});

var Gradient = function Gradient(props) {
  return React.createElement(Container, props, props.children);
};

var Primary = function Primary(props) {
  return React.createElement(Gradient, {
    from: props.theme.colours.primary.darker,
    to: props.theme.colours.primary.darker
  }, props.children);
};

var Secondary = function Secondary(props) {
  return React.createElement(Gradient, {
    from: props.theme.colours.secondary.darker,
    to: props.theme.colours.secondary.lighter
  }, props.children);
};

var Tertiary = function Tertiary(props) {
  return React.createElement(Gradient, {
    from: props.theme.colours.tertiary.darker,
    to: props.theme.colours.tertiary.lighter
  }, props.children);
};

var Custom = function Custom(props) {
  return React.createElement(Gradient, {
    from: props.gradient.from,
    to: props.gradient.to
  }, props.children);
};

export default Gradient;
export var GradientPrimary = withTheme(Primary);
export var GradientSecondary = withTheme(Secondary);
export var GradientTertiary = withTheme(Tertiary);
export var GradientPane = withTheme(Custom);